import { Address } from '../../../utils/checkoutState';
import { config } from '../../../utils/config';
import { reverseGeocode } from '../../../utils/geocode';
import { joinStreetHouseNumber } from '../../../utils/streetHouseNumber';
import { pushTrackingEvent } from '../../../utils/tracking';
import { CollectionPointSearchParams } from './Search';

export const getEmptySearch = (): CollectionPointSearchParams => ({
  streetHouseNumber: '',
  zipCode: '',
  city: '',
  maximumDistance: config.collectionPoints.defaultMaximumDistance * 1000,
});

export const getInitialSearchFromAddress = (address: Address): CollectionPointSearchParams => ({
  streetHouseNumber: joinStreetHouseNumber({
    country: { iso2Code: config.country },
    street: address.street,
    houseNumber: address.houseNumber,
  }),
  zipCode: address.zipCode ?? '',
  city: address.city,
  maximumDistance: config.collectionPoints.defaultMaximumDistance * 1000,
});

export const getInitialSearchFromCurrentPosition = async (): Promise<CollectionPointSearchParams | undefined> => {
  try {
    const position = await new Promise<GeolocationPosition>((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject)
    );
    const geocodedAddress = await reverseGeocode(position.coords);
    const { street, houseNumber, zipCode, city } = geocodedAddress;
    if (!street || !houseNumber || !zipCode || !city) {
      return undefined;
    }
    return {
      streetHouseNumber: joinStreetHouseNumber({ country: { iso2Code: config.country }, street, houseNumber }),
      zipCode,
      city,
      maximumDistance: config.collectionPoints.defaultMaximumDistance * 1000,
    };
  } catch (e: any) {
    console.error(e);
    pushTrackingEvent({
      event: 'error',
      action: 'collection_points_current_location',
      label: `${config.country}|${e.name}|${e.message}`,
      value: null,
    });
    return undefined;
  }
};
